<template>
    <div class="featured_slick_gallery gray home-slider" dir="ltr">
        <div class="featured_slick_gallery-slide">
            <div v-for="(image, index) in item" :key="index" class="featured_slick_padd">
                <router-link to="" class="mfp-gallery">
                    <img :src="image.image_url" class="img-fluid mx-auto" :alt="'Gallery image ' + (index + 1)" />
                </router-link>
            </div>
        </div>
        <!-- <router-link to="" class="btn-view-pic">View photos</router-link> -->
    </div>
</template>

<script setup>
    import { nextTick, onMounted, defineProps, ref } from 'vue';
    import $ from "jquery";
    import "slick-carousel";
    import 'slick-carousel/slick/slick.css';
    import 'slick-carousel/slick/slick-theme.css';

    const initialized = ref(false);

    defineProps({
        item: {
            type: Array,
            required: true
        }
    });

    const initializeSlickSlider = () => {
        nextTick(() => {
            const slider = $(".featured_slick_gallery-slide");
            try {
                if (slider.length > 0) {
                    if (slider.hasClass("slick-initialized")) {
                        slider.slick("unslick");
                    }
                    slider.slick({
                        dots: false,
                        infinite: true,
                        speed: 300,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: true,
                                    centerMode: true,
                                    centerPadding: '20px',
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    arrows: false,
                                    centerMode: true,
                                    
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                } else {
                    console.error("Slick Slider element not found!");
                }
            } catch (error) {
                console.error("Error initializing Slick Slider:", error);
            }
        });
    };

    onMounted(() => {
        if (!initialized.value) {
            initialized.value = true;
            initializeSlickSlider();
        }
    });
</script>
<style scoped>
.featured_slick_gallery-slide img {
  height: 350px; 
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
}
</style>